import { takeLatest, put, call } from "redux-saga/effects";
import { getRules } from "../../helpers/backend_helper";
import { getRuleFailed, getRuleSuccess } from "./actions";
import { GET_RULE } from "./actionsTypes";

function* onGetRule({ payload: params }) {
  try {
    const response = yield call(getRules, params);
    yield put(getRuleSuccess(response));
  } catch (error) {
    console.log(error);
    yield put(getRuleFailed(error.response));
  }
}

function* RuleSaga() {
  yield takeLatest(GET_RULE, onGetRule);
}

export default RuleSaga;
